import React from 'react';
import { FormBuilder } from 'commons-ui';

import { FORM_LAYOUT_CONFIG, VIEW_FORM_FIELD_CONFIG } from '../../utils/formConfig';

import useView from './useView';

const ViewAsset: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useView();

	return (
		<FormBuilder
			data={data}
			mode='view'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={VIEW_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: 'Back', submitLabel: 'Submit' }}
		/>
	);
};

export default ViewAsset;
